module.exports = __webpack_public_path__ + "img/3056440-83-3.566c507e.png";